import React from 'react'

const CaretRight = props => {
  return (
    <svg 
      width="8" 
      height="13" 
      viewBox="0 0 8 13" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M1.20078 11.8C1.01745 11.6167 0.925781 11.3834 0.925781 11.1C0.925781 10.8167 1.01745 10.5834 1.20078 10.4L5.10078 6.50005L1.20078 2.60005C1.01745 2.41672 0.925781 2.18338 0.925781 1.90005C0.925781 1.61672 1.01745 1.38338 1.20078 1.20005C1.38411 1.01672 1.61745 0.925049 1.90078 0.925049C2.18411 0.925049 2.41745 1.01672 2.60078 1.20005L7.20078 5.80005C7.30078 5.90005 7.37178 6.00838 7.41378 6.12505C7.45511 6.24172 7.47578 6.36672 7.47578 6.50005C7.47578 6.63338 7.45511 6.75838 7.41378 6.87505C7.37178 6.99172 7.30078 7.10005 7.20078 7.20005L2.60078 11.8C2.41745 11.9834 2.18411 12.075 1.90078 12.075C1.61745 12.075 1.38411 11.9834 1.20078 11.8Z" 
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default CaretRight
